// format date
const formatDateTime = (data) => {
  const splitDate = data.split("T");
  const [datePart, timePart] = splitDate;
  const [year, month, day] = datePart?.split("-");
  return `${day}-${month}-${year}`;
};

const getPublicIP = async () => {
  try {
    const res = await fetch("https://api.ipify.org?format=json");
    const data = await res.json();
    return data.ip; // example: "103.58.124.90"
  } catch (err) {
    console.error("Failed to get IP", err);
    return null;
  }
};

const serviceTypeMap = {
  Arrival: "1",
  Departure: "2",
  Transit: "3",
};

const IpAddress = await getPublicIP();

export const signupApiBody = (formData, bookingData, userOrder) => {
  // console.log("apiBody s",userOrder)

  const transformedAddons = Object.values(userOrder?.addon || {}).map(
    (item) => ({
      id: item.id,
      name: item.name,
      list_price: item.list_price,
      tax_price: item.tax_string, // formatted price string
      quantity: item.quantity,
      total: item.total?.toString() || "0", // safe conversion to string
    })
  );

  const packagePrice =
    userOrder?.product?.product?.tax_price * parseInt(bookingData?.adults);

  const childPackage = userOrder?.product?.productVariant?.filter(
    (item) => item?.variant?.toLowerCase() === "child",
  );

  const adultPackage = userOrder?.product?.productVariant?.filter(
    (item) => item?.variant?.toLowerCase() === "adult",
  );
  const childPackagePrice =
    bookingData?.child > 0
      ? childPackage?.[0]?.tax_price *
        parseInt(bookingData?.child)
      : 0;

  const addonTotal = Object.values(userOrder?.addon).reduce((acc, item) => {
    return acc + item.tax_price * item.quantity;
  }, 0);
  const totalAmount = packagePrice + childPackagePrice + addonTotal;
  return {
    parentOrderDetails: {
      category: bookingData.type,
      travel_date:
        bookingData?.type === "Departure"
          ? formatDateTime(bookingData.dateOfDeparture)
          : formatDateTime(bookingData.dateOfArrival),
      sector: bookingData.sector,
      no_of_adult: parseInt(bookingData.adults),
      no_of_children: parseInt(bookingData.child),
      no_of_infants: parseInt(bookingData.infant),
      commitment_date:
        bookingData?.type === "Departure"
          ? `${formatDateTime(bookingData.dateOfDeparture)} ${bookingData.std}`
          : `${formatDateTime(bookingData.dateOfArrival)} ${bookingData.sta}`,
      primary_product_id: userOrder?.product?.product?.id,
      terminal_id: "1",
      length_stay: 0,
      pricelist_id: 0,
      ipaddress: IpAddress || "109.38.225.250",
      save_sale_order_parent_id: 0,
      airport: {
        airport_location_id: "8008",
        airport_terminal_id: bookingData?.sector === "Domestic" ? "1" : "2",
        airport_terminal_code: bookingData?.sector === "Domestic" ? "90" : "180",
        from_airport_id: bookingData?.type === "Departure" ? "8008" : bookingData.originAirport,
        to_airport_id: bookingData?.type === "Arrival" ? "8008" : bookingData.destinationAirport,
        service_category: "welcome_and_assist",
        service_type_id: serviceTypeMap[bookingData?.type],
        booking_made_from: null,
      },
      arrival: {
        arrival_flight_id: bookingData.flight.id,
        arrival_flight_no: bookingData.flight.name,
        arrival_airline_id: bookingData.flight.airline_id[0],
        arrival_airline_name: bookingData.flight.airline_id[1],
        arrival_time: bookingData.sta,
        arrival_term: bookingData.flight.arrival_term,
        arrival_from_airport: "Indira Gandhi International Airport",
        arrival_to_airport: bookingData?.originAirportName,
      },
      departure: {
        departure_flight_id: bookingData?.type === "Transit" ? bookingData?.flight2?.id : bookingData?.flight?.id,
        departure_flight_no: bookingData?.type === "Transit" ? bookingData?.flight2?.name : bookingData?.flight?.name,
        departure_airline_id: bookingData?.type === "Transit" ? bookingData?.flight2?.airline_id[0] : bookingData?.flight?.airline_id[0],
        departure_airline_name: bookingData?.type === "Transit" ? bookingData?.flight2?.airline_id[1] : bookingData?.flight?.airline_id[1],
        departure_time: bookingData?.type === "Transit" ? bookingData?.std : bookingData?.sta,
        departure_term: bookingData?.type === "Transit" ? bookingData?.flight2?.departure_term : bookingData?.flight?.arrival_term,
        departure_from_airport: "Indira Gandhi International Airport",
        departure_to_airtport: bookingData?.destinationAirportName,
      },
      transit: {
        transit_airport_service: null,
        transit_from_airtport: bookingData.originAirport,
        transit_to_airtport: bookingData.destinationAirport,
        transit_arrival_flight: bookingData.flight.id,
        transit_departure_flight: bookingData.flight2.id,
      },
    },
    product: {
      data: [
        {
          product_id: adultPackage?.[0]?.id,
          name: adultPackage?.[0]?.name,
          product_uom_qty: bookingData.adults.toString(),
          price_unit: parseFloat(
            adultPackage?.[0]?.lst_price
          ).toFixed(2),
          price_subtotal: (
            adultPackage?.[0]?.tax_price * bookingData.adults
          ).toString(),
        },
        bookingData.child && bookingData.child > 0
          ? {
              product_id: childPackage?.[0]?.id,
              name: childPackage?.[0]?.name,
              product_uom_qty: bookingData.child.toString(),
              price_unit: parseFloat(
                childPackage?.[0]?.lst_price
              ).toFixed(2),
              price_subtotal: (
                childPackage?.[0]?.tax_price *
                bookingData.child
              ).toString(),
            }
          : null,
      ],
    },
    addons: {
      data: transformedAddons,
    },
    paidAmount: totalAmount,
    userDetails: {
      save_sale_order_parent_id: "",
      title: formData.title?.split("-")[0],
      title_text: formData.title_text,
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      gender: formData.gender,
      mobile: formData.mobile,
      dob: formData.dateOfBirth,
      countryCode: formData.country,
      address: formData.fullAddress,
      city: formData.city,
      state: formData.state,
      countryId: formData.country,
      pincode: formData.pincode,
      password: formData.password,
      tnc: "yes",
      mkt_comm: "yes",
      consent: "true",
    },
  };
};

export const loginApiBody = (userCred, bookingData, userOrder) => {
  // console.log("apiBody l",bookingData)
  const childPackage = userOrder?.product?.productVariant?.filter(
    (item) => item?.variant?.toLowerCase() === "child",
  );
  const adultPackage = userOrder?.product?.productVariant?.filter(
    (item) => item?.variant?.toLowerCase() === "adult",
  );

  const packagePrice =
    userOrder?.product?.product?.tax_price * parseInt(bookingData?.adults);
  const childPackagePrice =
    bookingData?.child > 0 &&
    childPackage?.length > 0
      ? childPackage?.[0]?.tax_price *
        parseInt(bookingData?.child)
      : 0;

  const addonTotal = Object.values(userOrder?.addon).reduce((acc, item) => {
    return acc + item.tax_price * item.quantity;
  }, 0);

  const totalAmount = packagePrice + childPackagePrice + addonTotal;

  const transformedAddons = Object.values(userOrder?.addon || {}).map(
    (item) => ({
      id: item.id,
      name: item.name,
      list_price: item.list_price,
      tax_price: item.tax_string, // formatted price string
      quantity: item.quantity,
      total: item.total?.toString() || "0", // safe conversion to string
    })
  );

  const apiBody = {
    parentOrderDetails: {
      category: bookingData.type,
      travel_date:
        bookingData?.type === "Departure"
          ? formatDateTime(bookingData.dateOfDeparture)
          : formatDateTime(bookingData.dateOfArrival),
      sector: bookingData.sector,
      no_of_adult: parseInt(bookingData.adults),
      no_of_children: parseInt(bookingData.child),
      no_of_infants: parseInt(bookingData.infant),
      commitment_date:
        bookingData?.type === "Departure"
          ? `${formatDateTime(bookingData.dateOfDeparture)} ${bookingData.std}`
          : `${formatDateTime(bookingData.dateOfArrival)} ${bookingData.sta}`,
      primary_product_id: userOrder?.product?.product?.id,
      terminal_id: "1",
      length_stay: 0,
      pricelist_id: 0,
      ipaddress: IpAddress || "109.38.225.250",
      save_sale_order_parent_id: 0,
      airport: {
        airport_location_id: "8008",
        airport_terminal_id: bookingData?.sector === "Domestic" ? "1" : "2",
        airport_terminal_code: bookingData?.sector === "Domestic" ? "90" : "180",
        from_airport_id: bookingData?.type === "Departure" ? "8008" : bookingData.originAirport,
        to_airport_id: bookingData?.type === "Arrival" ? "8008" : bookingData.destinationAirport,
        service_category: "welcome_and_assist",
        service_type_id: serviceTypeMap[bookingData?.type],
        booking_made_from: null,
      },
      arrival: {
        arrival_flight_id: bookingData.flight.id,
        arrival_flight_no: bookingData.flight.name,
        arrival_airline_id: bookingData.flight.airline_id[0],
        arrival_airline_name: bookingData.flight.airline_id[1],
        arrival_time: bookingData.sta,
        arrival_term: bookingData.flight.arrival_term,
        arrival_from_airport: "Indira Gandhi International Airport",
        arrival_to_airport: bookingData?.originAirportName,
      },
      departure: {
        departure_flight_id: bookingData?.type === "Transit" ? bookingData?.flight2?.id : bookingData?.flight?.id,
        departure_flight_no: bookingData?.type === "Transit" ? bookingData?.flight2?.name : bookingData?.flight?.name,
        departure_airline_id: bookingData?.type === "Transit" ? bookingData?.flight2?.airline_id[0] : bookingData?.flight?.airline_id[0],
        departure_airline_name: bookingData?.type === "Transit" ? bookingData?.flight2?.airline_id[1] : bookingData?.flight?.airline_id[1],
        departure_time: bookingData?.type === "Transit" ? bookingData?.std : bookingData?.sta,
        departure_term: bookingData?.type === "Transit" ? bookingData?.flight2?.departure_term : bookingData?.flight?.departure_term,
        departure_from_airport: "Indira Gandhi International Airport",
        departure_to_airtport: bookingData?.destinationAirportName,
      },
      transit: {
        transit_airport_service: null,
        transit_from_airtport: bookingData.originAirport,
        transit_to_airtport: bookingData.destinationAirport,
        transit_arrival_flight: bookingData.flight.id,
        transit_departure_flight: bookingData.flight2.id,
      },
    },
    product: {
      data: [
        {
          product_id: adultPackage?.[0]?.id,
          name: adultPackage?.[0]?.name,
          product_uom_qty: bookingData.adults.toString(),
          price_unit: parseFloat(
            adultPackage?.[0]?.lst_price
          ).toFixed(2),
          price_subtotal: (
            adultPackage?.[0]?.tax_price * bookingData.adults
          ).toString(),
        },
        bookingData.child > 0
          ? {
              product_id: childPackage?.[0]?.id,
              name: childPackage?.[0]?.name,
              product_uom_qty: bookingData.child.toString(),
              price_unit: parseFloat(
                childPackage?.[0]?.lst_price
              ).toFixed(2),
              price_subtotal: (
                childPackage?.[0]?.tax_price *
                bookingData.child
              ).toString(),
            }
          : null,
      ],
    },
    addons: {
      data: transformedAddons,
    },
    credentials: {
      username: userCred.email,
      password: userCred.password,
    },

    paidAmount: totalAmount,
  };

  return apiBody;
};

export const formatPlaceOrderApiBody = (user, billingDetails) => {
  const guests = billingDetails.guest.map((guest) => {
    const obj = {
      title: guest.title.split("-")[0],
      title_text: guest.title.split("-")[1] || "Mr/Ms",
      class_type: guest.travelClass,
      gender: guest.gender,
      first_name: guest.first_name,
      last_name: guest.last_name,
      age: guest.age,
      pnr_no: guest.pnr,
      passport_no: guest.passport,
    };
    return obj;
  });

  const child = billingDetails.child
    ? billingDetails.child.map((guest) => {
        const obj = {
          title: guest.title.split("-")[0],
          title_text: guest.title.split("-")[1] || "Mr/Ms",
          class_type: guest.travelClass,
          gender: guest.gender,
          first_name: guest.first_name,
          last_name: guest.last_name,
          age: guest.age,
          pnr_no: guest.pnr,
          passport_no: guest.passport,
        };
        return obj;
      })
    : [];

  const infant = billingDetails.infant
    ? billingDetails.infant.map((guest) => {
        const obj = {
          title: guest.title.split("-")[0],
          title_text: guest.title.split("-")[1] || "Mr/Ms",
          class_type: guest.travelClass,
          gender: guest.gender,
          first_name: guest.first_name,
          last_name: guest.last_name,
          age: guest.age,
          pnr_no: guest.pnr,
          passport_no: guest.passport,
        };
        return obj;
      })
    : [];

  const apiBody = {
    customerId: user.customerId,
    bookingId: user.bookingId,
    guests: [...guests, ...child, ...infant],
    placard: {
      title:
        billingDetails?.billingFormData?.placard?.title.split("-")[0] || "",
      title_text:
        billingDetails?.billingFormData?.placard?.title.split("-")[1] ||
        "Mr/Ms",
      first_name: billingDetails?.billingFormData?.placard?.firstName,
      last_name: billingDetails?.billingFormData?.placard?.lastName,
      country_code: billingDetails?.billingFormData?.placard?.countryCode,
      mobile: billingDetails?.billingFormData?.placard?.mobile,
      billing_title: billingDetails?.billingFormData?.billing?.title,
      billing_name: billingDetails?.billingFormData?.billing?.firstName,
      billing_last_name: billingDetails?.billingFormData?.billing?.lastName,
      billing_country_code:
        billingDetails?.billingFormData?.billing?.countryCode,
      billing_country_value: "India",
      billing_mobile: billingDetails?.billingFormData?.billing?.mobile,
      billing_address: billingDetails?.billingFormData?.billing?.address,
      billing_city: billingDetails?.billingFormData?.billing?.city,
      billing_country: billingDetails?.billingFormData?.billing?.country,
      billing_state: billingDetails?.billingFormData?.billing?.state,
      billing_state_value: billingDetails?.billingFormData?.billing?.state,
      billing_pincode: billingDetails?.billingFormData?.billing?.pincode,
      billing_email_id: billingDetails?.billingFormData?.billing?.email,
      billing_entity_name: billingDetails?.gst?.entityName,
      billing_gst_no: billingDetails?.gst?.gstin,
    },
  };

  return apiBody;
};
